const qBank = [
  {
    level:"1. Behavior",
    question: "Think about a recent situation that you found stressful. What happened?",
    TellMeMoreText: "Describe concrete, observable circumstances. Don’t provide commentary on your feelings…yet—gotta walk before we run!",
    example: "I bombed an important job interview...",
    vocabArray:[],
    order: 1
  },

  {
    level:"2. Coping",
    question: "What did you do to deal with this situation?",
    TellMeMoreText: "We all cope with stress differently. We might have a good cry, lose ourselves in work, buy a mountain of cheeseburgers, or shut down completely. Describe your response to your stressful experience.",
    example: "I went home and played video games for the rest of the day, ignoring the work I had waiting...",
    vocabArray:[ 
      
    ],
    order: 2
  },
  {
    level: "3. Feelings",
    question: "Without self-judgement, allow any and all feelings to come.",
    TellMeMoreText: " “Ok, now we can talk about feelings. Describe the emotions you’re feel about what happened. Don’t worry if they are conflicting or confusing—feelings are rarely cohesive.",
    example: "I felt like a failure...",
    vocabArray:[ 
      ["Ecstatic", "Thrilled", "Excited"],
      ["Sad", "Happy", "Mad"],
      ["Discouraged", "Intimidated", "Bright"],
    ],
    order: 3
  },
  {
    level: "4. Feelings About Feelings",
    question: "What reaction does expressing your feelings stir in you?",
    TellMeMoreText: "If the feelings you expressed first were true, what do you think that would mean about you? Your feelings are always valid and real, but they are not always true.",
    example: "I feel silly for making such a big deal out of it...",
    vocabArray:[ 
      ["Ecstatic", "Thrilled", "Excited"],
      ["Sad", "Happy", "Mad"],
      ["Discouraged", "Intimidated", "Bright"],
    ],
    order: 4
  },
  {
    level: "5. Perceptions",
    question: "What beliefs, assumptions and values affected how you perceive this situation?",
    TellMeMoreText: "Perceptions are the lens through which we see the world. Consider the outside influences things like your cultural or religious background might have on your perspective.",
    example: "If I'm not pulling my weight, I'm not being a good mom...",
    vocabArray:[ 
      ["Ecstatic", "Thrilled", "Excited"],
      ["Sad", "Happy", "Mad"],
      ["Discouraged", "Intimidated", "Bright"],
    ],
    order: 5
  },
  {
    level: "6. Expectations",
    question: "What did you expect of yourself or of others in this situation?",
    TellMeMoreText: "This can be tricky as expectations are often subtle or subconscious. Ask yourself if these expectations were met, unmet, reasonable or unreasonable, communicated, or uncommunicated.",
    example: "I thought that if I just showed up and did my best, I would have shot...",
    vocabArray:[ 
      ["Ecstatic", "Thrilled", "Excited"],
      ["Sad", "Happy", "Mad"],
      ["Discouraged", "Intimidated", "Bright"],
    ],
    order: "6"
  },
  {
    level: "7. Yearnings",
    question: "What were you hoping for on a deeper level?",
    TellMeMoreText: "Dig deep. You’re almost there. If you find yourself yearning for something more transitory (like a promotion, an event, a relationship), go past that and ask what yearnings you thought a job would fulfill (respect, affirmation, security, etc.)",
    example: "I want stability, to not be dependent on other people for my needs...",
    vocabArray:[ 
      ["Ecstatic", "Thrilled", "Excited"],
      ["Sad", "Happy", "Mad"],
      ["Discouraged", "Intimidated", "Bright"],
    ],
    order: 7
  },
  {
    level: "8. Self",
    question: "In light of all this, who are you?",
    TellMeMoreText: "When faced with the fear that our yearnings might never be met, we often bump into a core false belief about ourselves... When our deepest yearnings are denied, we might assume our needs will never be met. We might fear that connection, affirmation or love will always be outside our grasp. This is not the truth. But it is important to face that fear.",
    example: "Even if I can't provide for myself, I'm still a valuable person. I don't need to feel ashamed if I can't perform perfectly all the time...",
    vocabArray:[ 
      ["Ecstatic", "Thrilled", "Excited"],
      ["Sad", "Happy", "Mad"],
      ["Discouraged", "Intimidated", "Bright"],
    ],
    order: 8
  },
]



export default qBank


// Ecstatic,
// Elated,
// Energetic,
// Euphoric,
// Excited,
// Exhilarated,
// Overjoyed,
// Thrilled,
// Vibrant,



// Adrift
// Ambivalent
// Bewildered
// Puzzled
// Blurred
// Disorganized
// Disquieted
// Disturbed
// Dizzy 

// Annoyed
// Antagonistic
// Crabby
// Cranky
// Exasperated
// Fuming
// Grouchy
// Hostile
// Indignant 